import { Injectable } from '@angular/core';
import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { MedicalLetterType } from '../../models/medical-letter-types/medical-letter-type';

@Injectable()
export class MedicalLetterTypeService extends Service{

    public medicalLetters: MedicalLetterType[];
    public medicalLetterTypesObject: any;

    constructor(
        private http: HttpClientService
    ) {
        super();
        this.medicalLetters = [];
        this.medicalLetterTypesObject = {};
    }

    public getAll(): Observable<MedicalLetterType[]> {
        if (!!this.medicalLetters && this.medicalLetters.length > 0) {
            return Observable.create((observer: Subscriber<MedicalLetterType[]>) => {
                observer.next(this.medicalLetters);
                observer.complete();
            });
        }
        const url = 'medicallettertypes/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.medicalLetters = r.Result;
                this.medicalLetterTypesObject = this.medicalLetters.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('divisionsService > getAll > response', r);
            }
            return this.medicalLetters;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/medical-letter-types/medical-letter-type.service.ts